module.exports = __webpack_public_path__ + "static/media/WH5.47501111.png";